import React from 'react';
import classNames from 'classnames';
import SkeletonLines from './components/skeleton-lines';

const TextSkeleton = ({ width = '', lines = 1, centered = false }) => {
  const classes = classNames('ws-ui-text-skeleton', {
    'ws-ui-text-skeleton--centered': centered,
  });
  return (
    <span
      className={classes}
      style={{
        maxWidth: width,
      }}
    >
      <SkeletonLines lines={lines} />
    </span>
  );
};

export default TextSkeleton;
